document.addEventListener('DOMContentLoaded', () => {
  const slideshow = document.querySelector('.monaco-slideshow');
  if (!slideshow) return;

  const slides = slideshow.querySelectorAll('.monaco-slide');
  const dots = slideshow.querySelectorAll('.monaco-slideshow-dot');
  const prevBtn = slideshow.querySelector('.monaco-arrow-prev');
  const nextBtn = slideshow.querySelector('.monaco-arrow-next');

  if (slides.length === 0) return;

  let currentSlide = 0;
  let autoplayTimer = null;
  
  const isAutoplay = slideshow.dataset.autoplay === 'true';
  const autoplaySpeed = parseInt(slideshow.dataset.speed) || 5000;

  // 1. Show Specific Slide
  function showSlide(index) {
    // Boundary handling
    if (index >= slides.length) {
      currentSlide = 0;
    } else if (index < 0) {
      currentSlide = slides.length - 1;
    } else {
      currentSlide = index;
    }

    // Update active slide class
    slides.forEach((slide, i) => {
      if (i === currentSlide) {
        slide.classList.add('active');
      } else {
        slide.classList.remove('active');
      }
    });

    // Update active dot class
    dots.forEach((dot, i) => {
      if (i === currentSlide) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });

    // Reset autoplay timer if active
    if (isAutoplay) {
      startAutoplay();
    }
  }

  // 2. Autoplay controls
  function startAutoplay() {
    stopAutoplay();
    autoplayTimer = setInterval(() => {
      showSlide(currentSlide + 1);
    }, autoplaySpeed);
  }

  function stopAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
    }
  }

  // 3. Event Listeners for controls
  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      showSlide(currentSlide + 1);
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      showSlide(currentSlide - 1);
    });
  }

  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      const targetIndex = parseInt(dot.dataset.index);
      showSlide(targetIndex);
    });
  }
  );

  // Initialize Autoplay
  if (isAutoplay) {
    startAutoplay();
  }
});
